define([
    "jquery",
    "underscore",
    "marionette",
    "holdon"
], function ($, _, Marionette) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui: {
            'yesButton': '#yes-button',
            'noButton': '#no-button'
        },

        events: {
            'click @ui.yesButton': 'yesAction',
            'click @ui.noButton': 'noAction'
        },

        initialize: function () {
            this.bindUIElements();
        },

        yesAction: function () {
            let pathArray = window.location.pathname.split('/');
            let token = pathArray[3];

            HoldOn.open({
                theme: "sk-fading-circle"
            });

            $.ajax('/rest_email/unsubscribe_agreed', {
                method: "POST",
                data: {
                    token: token
                },
                success: function (data) {
                    alert("Successfully unsubscribed");
                    HoldOn.close();
                },
                error: function (xhr, textStatus, errorThrown) {
                    alert(xhr.responseJSON.message)
                    HoldOn.close();
                }
            });
        },

        noAction: function () {
            window.location.href = "/";
        }
    });
});
